//
//
//
//
//
//
//
//
//
//
//
import chukou from "./com/chukou";
import dongjiang from "./com/dongjiang";
import jinchu from "./com/jinchu";
import jinkou from "./com/jinkou";
import tushan from "./com/tushan";
import xijiang from "./com/xijiang";
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'SystemFlow',
  mixins: [GetSiteIdMixin],
  components: {
    chukou: chukou,
    dongjiang: dongjiang,
    jinchu: jinchu,
    jinkou: jinkou,
    tushan: tushan,
    xijiang: xijiang
  },
  data: function data() {
    return {
      siteId: ''
    };
  },
  mounted: function mounted() {},
  methods: {},
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] && ids[0] == 1) {
        // 根据站点id
        this.siteId = ids[1];
      } else {// 根据区域id
      }
    }
  }
};